export default {
    Generated: 0,
    Manufactured: 1,
    Delivered: 2,
    Received: 3,
}


// WEBPACK FOOTER //
// ./src/components/application/QRC/status.js